const initializeMaeveCommunity = (scope = document) => {
  scope.querySelectorAll('[data-ml-community]').forEach((section) => {
    const rail = section.querySelector('[data-community-rail]');
    const toggle = section.querySelector('[data-community-toggle]');
    if (!rail || rail.dataset.autoScrollReady === 'true') return;
    rail.dataset.autoScrollReady = 'true';

    const originals = [...rail.children];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let interactionPaused = false;
    let userPaused = reducedMotion;
    let frame;
    let previousTime;

    if (originals.length > 1 && !reducedMotion) {
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('img').forEach((image) => { image.alt = ''; });
        rail.appendChild(clone);
      });
    }

    const cycleWidth = () => {
      const duplicate = rail.children[originals.length];
      return duplicate ? duplicate.offsetLeft - originals[0].offsetLeft : 0;
    };
    const renderToggle = () => {
      if (!toggle) return;
      toggle.hidden = reducedMotion;
      const paused = userPaused || reducedMotion;
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.querySelector('[data-pause-label]').hidden = paused;
      toggle.querySelector('[data-play-label]').hidden = !paused;
    };
    const animate = (time) => {
      if (!previousTime) previousTime = time;
      if (!interactionPaused && !userPaused && !reducedMotion) {
        rail.scrollLeft += (time - previousTime) * (Number(rail.dataset.speed || 25) / 1000);
        const width = cycleWidth();
        if (width > 0 && rail.scrollLeft >= width) rail.scrollLeft -= width;
      }
      previousTime = time;
      frame = requestAnimationFrame(animate);
    };
    const pauseInteraction = () => { interactionPaused = true; };
    const resumeInteraction = () => { interactionPaused = false; previousTime = performance.now(); };

    rail.addEventListener('mouseenter', pauseInteraction);
    rail.addEventListener('mouseleave', resumeInteraction);
    rail.addEventListener('focusin', pauseInteraction);
    rail.addEventListener('focusout', resumeInteraction);
    rail.addEventListener('pointerdown', pauseInteraction);
    rail.addEventListener('pointerup', resumeInteraction);
    rail.addEventListener('pointercancel', resumeInteraction);
    rail.addEventListener('touchstart', pauseInteraction, { passive: true });
    rail.addEventListener('touchend', resumeInteraction, { passive: true });
    toggle?.addEventListener('click', () => { userPaused = !userPaused; renderToggle(); });

    renderToggle();
    frame = requestAnimationFrame(animate);
    section.addEventListener('shopify:section:unload', () => cancelAnimationFrame(frame), { once: true });
  });
};

initializeMaeveCommunity();
document.addEventListener('shopify:section:load', (event) => initializeMaeveCommunity(event.target));
